import styled from 'styled-components';

export const Container = styled.section`
  /* display: ${({ isShown }) => (isShown ? 'flex' : 'none')}; */

  /* justify-content: center; */

  width: 100%;
  /* padding-bottom: 50px; */
  margin-top: 20px;
  padding:  0 70px 50px 0;
  /* width: 100%; */
`;
export const Title = styled.h3`
  color: #145b99;
  font-weight: bold;
  font-size: ${(props) => props.fontSize || '14px' };
  margin-left: 26px;
  text-transform: uppercase;
`;

export const FootWrapper = styled.div`
  height: 6px;
  display: flex;
  /* flex-wrap: wrap; */
  flex-direction: column;
  flex: 1;
  align-content: flex-start;
  margin: 15px 0 35px 0;
`;
export const FootThick = styled.div`
  width: 17%;
  height: 6px;
  background: #145b99;
`;
export const FootLight = styled.div`
  height: 3px;
  width: 83%;
  background: #f4f4f4;
`;

export const WrapperContent = styled.div`
  display: flex;
  align-items: stretch;
  flex-direction: column;
  flex: 1;
`;
